import React, { useState } from "react";
// For react-router v5; if you are using v6, import useNavigate instead of useHistory.
import { useLocation, useNavigate } from "react-router-dom";

import { Form, Button, Alert, Container } from "react-bootstrap";
import API from "../api";

// Utility hook to get query parameters
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPasswordPage = () => {
  const query = useQuery();
  const token = query.get("token");
  const navigate = useNavigate();

   
  const [newPassword, setNewPassword] = useState("");
  const [resetMessage, setResetMessage] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/users/reset-password", { token, newPassword });
      setResetMessage(res.data.message || "Password has been reset successfully.");
      // Redirect to the login page after a short delay (1.5 seconds)
      setTimeout(() => {
        navigate("/auth");
      }, 1500);
      
    } catch (error) {
      setResetMessage(error.response?.data?.message || "Failed to reset password.");
    }
  };

  return (
    <Container style={{ maxWidth: "400px", marginTop: "50px" }}>
      <h3>Reset Password</h3>
      {resetMessage && <Alert variant="info">{resetMessage}</Alert>}
      <Form onSubmit={handleResetPassword}>
        <Form.Group controlId="newPassword">
          <Form.Label>New Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter new password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" type="submit" style={{ marginTop: "10px" }}>
          Reset Password
        </Button>
      </Form>
    </Container>
  );
};

export default ResetPasswordPage;
